// Keys under which data is stored in the browser storage systems

export const READER_BOOK = 'reader_book'
export const SELECTED_PAYPAL_PLAN = 'selected_paypal_plan'
export const PATH_FOR_SUCCESS_PAGE = 'path_for_sucess_page'
